/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Tab_TrainingInputs */

const en_ui_labs_tab_training = /** @type {(inputs: Ui_Labs_Tab_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const de_ui_labs_tab_training = /** @type {(inputs: Ui_Labs_Tab_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

/**
* | output |
* | --- |
* | "Training" |
*
* @param {Ui_Labs_Tab_TrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_tab_training = /** @type {((inputs?: Ui_Labs_Tab_TrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Tab_TrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_tab_training(inputs)
	return de_ui_labs_tab_training(inputs)
});